import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useNavigate } from "react-router-dom";
import { useFetchMeQuery } from "../../store";
import { PERSONEL } from "../../roles";
import AnnouncementSlider from "./AnnouncementSlider";

const quickLinks = [
  {
    title: "İzin Yönetimi",
    desc: "İzin taleplerini görüntüle ve yönet",
    icon: <BeachAccessIcon sx={{ fontSize: 40, color: "#7c3aed" }} />,
    path: "/izinler",
    color: "#f5f3ff",
    border: "#7c3aed",
    roles: "all",
  },
  {
    title: "Personel Listesi",
    desc: "Tüm personelleri görüntüle",
    icon: <PeopleAltIcon sx={{ fontSize: 40, color: "#0284c7" }} />,
    path: "/personel-list",
    color: "#f0f9ff",
    border: "#0284c7",
    roles: "manager",
  },
  {
    title: "Yeni Personel",
    desc: "Sisteme yeni personel ekle",
    icon: <PersonAddIcon sx={{ fontSize: 40, color: "#059669" }} />,
    path: "/new-personel",
    color: "#f0fdf4",
    border: "#059669",
    roles: "manager",
  },
  {
    title: "Uygulama Yönetimi",
    desc: "İzin tipleri, departmanlar ve ekipler",
    icon: <SettingsIcon sx={{ fontSize: 40, color: "#d97706" }} />,
    path: "/application-management",
    color: "#fffbeb",
    border: "#d97706",
    roles: "manager",
  },
];

const HomePage = () => {
  const navigate = useNavigate();
  const { data: user } = useFetchMeQuery();
  const isPersonel = user?.roleId === PERSONEL;

  const visibleLinks = quickLinks.filter(
    (l) => l.roles === "all" || !isPersonel
  );

  return (
    <Box
      sx={{
        mt: { xs: 10, sm: 12 },
        px: { xs: 2, sm: 4, md: 8 },
        pb: 6,
        minHeight: "80vh",
      }}
    >
      {/* ── Slider (üstte) ── */}
      {!isPersonel && <AnnouncementSlider />}

      {/* ── Hoşgeldin Banner ── */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
          borderRadius: 4,
          p: { xs: 3, sm: 5 },
          mb: 5,
          color: "#fff",
          boxShadow: "0 8px 32px rgba(30,41,59,0.18)",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{ mb: 1, letterSpacing: -0.5 }}
        >
          Hoş Geldin
          {user?.firstName ? `, ${user.firstName}` : ""} 👋
        </Typography>
        <Typography variant="body1" sx={{ color: "#94a3b8" }}>
          İK Yönetim Paneline hoş geldiniz. Aşağıdan hızlı erişim
          linklerini kullanabilirsiniz.
        </Typography>
      </Box>

      {/* ── Hızlı Erişim Kartları ── */}
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ mb: 3, color: "text.primary" }}
      >
        Hızlı Erişim
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr 1fr",
          },
          gap: 3,
        }}
      >
        {visibleLinks.map((link) => (
          <Card
            key={link.title}
            sx={{
              borderRadius: 3,
              border: `2px solid ${link.border}22`,
              boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
              bgcolor: link.color,
              transition: "transform 0.18s, box-shadow 0.18s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: `0 8px 24px ${link.border}33`,
              },
            }}
          >
            <CardActionArea
              onClick={() => navigate(link.path)}
              sx={{ p: 1, height: "100%" }}
            >
              <CardContent>
                <Stack spacing={1.5}>
                  <Box>{link.icon}</Box>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ color: link.border }}
                  >
                    {link.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {link.desc}
                  </Typography>
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default HomePage;
